module.exports = __webpack_public_path__ + "img/neobet_2026_V4_640x200.df03b829.png";